import { configureStore } from "@reduxjs/toolkit";
import countriesReducer from "./slices/countriesSlice";
import userReducer from "./slices/userSlice"; 
import loadingReducer from "./slices/loadingSlice";

const store = configureStore({
    reducer: {
        country: countriesReducer,
        user: userReducer,
        loading: loadingReducer,
    },
});

export default store;
